import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Main } from '~/components/shell/main';
import { SettingsNav } from '~/features/settings/settings-nav';

/**
 * The settings pages (web-app.md section 9): one main box holding the settings
 * sub-nav and, beside it, the page, which draws itself as a column of this box.
 */
export const Route = createFileRoute('/_app/account')({
  component: () => (
    <Main className="flex-row">
      <SettingsNav />
      <Outlet />
    </Main>
  ),
});
